import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotfoundComponent } from './notfound.component';
import { HomeComponent } from './home/home.component';
import { AuthGuard } from './_guards';
import { LoginComponent } from './_login/login/login.component';
import { HandleLoginComponent } from './_login/login/handle-login.component';
import { NotasShellComponent } from './alumnos/notas-shell/notas-shell.component';
import { PhotoBookComponent } from './_tools/photo-book/photo-book.component';
import { ResetComponent } from './_login/reset/reset.component';

import { HistoricoRecordComponent } from './historico-record/historico-record-excel/historico-record.component';

const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'handle-login/:token/:returnUrl',
    component: HandleLoginComponent
  },
  {
    path: 'handle-login/:token',
    component: HandleLoginComponent
  },
  {
    path: 'reset',
    component: ResetComponent
  },
  {
    path: 'notas-estudiante',
    component: NotasShellComponent,
  },
  // Lazy loaded modules
  {
    path: 'materia',
    loadChildren: () => import('./materia/materia.module')
      .then(m => m.MateriaModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'matricula',
    loadChildren: () => import('./_modules/matricula/matricula.module')
      .then(m => m.MatriculaModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'actualizacion',
    loadChildren: () => import('./_modules/glm-actualizacion-datos/glm-actualizacion-datos.module')
      .then(m => m.GlmActualizacionDatosModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'admisiones',
    loadChildren: () => import('./admisiones/admisiones.module')
      .then(m => m.AdmisionesModule),
    // canActivate: [AuthGuard]
  },
  {
    path: 'admisiones-registro',
    loadChildren: () => import('./_modules/registro-admisiones/registro-admisiones.module')
      .then(m => m.RegistroAdmisionesModule),
  },
  {
    path: 'asistencia-general',
    loadChildren: () => import('./asistencia-general/asistencia-general.module')
      .then(m => m.AsistenciaGeneralModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'alumnos',
    loadChildren: () => import('./alumnos/alumnos.module')
      .then(m => m.AlumnosModule),
    canActivate: [AuthGuard]
  },
   {
    path: 'director-grupo',
    loadChildren: () => import('./director-grupo/director-grupo.module')
      .then(m => m.DirectorGrupoModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'permiso',
    loadChildren: () => import('./asistencia-permiso/permiso.module')
      .then(m => m.PermisoModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'asistencia',
    loadChildren: () => import('./_modules/asistencia/asistencia.module')
      .then(m => m.AsistenciaModule),
    canActivate: [AuthGuard]
  },

  {
    path: 'reconocimientos',
    loadChildren: () => import('./_modules/reconocimientos/reconocimientos.module')
      .then(m => m.ReconocimientosModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'encuestas',
    loadChildren: () => import('./_modules/encuestas/encuestas.module')
      .then(m => m.EncuestasModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'horario',
    loadChildren: () => import('./_modules/calendario/calendario.module')
      .then(m => m.CalendarioModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'informes',
    loadChildren: () => import('./informes/informe.module')
      .then(m => m.InformeModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'informesv25',
    loadChildren: () => import('./informes25/informes25.module')
      .then(m => m.Informes25Module),
    canActivate: [AuthGuard]
  },
  {
    path: 'sgc',
    loadChildren: () => import('./calidad/calidad.module')
      .then(m => m.CalidadModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'internal',
    loadChildren: () => import('./internal/internal.module')
      .then(m => m.InternalModule),
    canActivate: [AuthGuard]
  },
  // {
  //   path: 'permisos',
  //   loadChildren: () => import('./_modules/permisos/permisos.module')
  //     .then(m => m.PermisosModule),
  //   canActivate: [AuthGuard]
  // },
  {
    path: 'deprecated/reuniones',
    loadChildren: () => import('./_modules/reuniones/reuniones.module')
      .then(m => m.ReunionesModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'v1/admisiones',
    loadChildren: () => import('./_modules/admisiones/admisiones.module')
      .then(m => m.AdmisionesModule),
  },
  {
    path: 'reuniones',
    loadChildren: () => import('./reuniones/reuniones.module')
      .then(m => m.ReunionesV2Module),
    canActivate: [AuthGuard]
  },
  {
    path: 'servicios-generales',
    loadChildren: () => import('./servicios-generales/servicios-generales.module')
      .then(m => m.ServiciosGeneralesModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'v2/matriculas',
    loadChildren: () => import('./matricula/matricula.module')
      .then(m => m.MatriculaModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'pmp',
    loadChildren: () => import('./pmp/pmp.module')
      .then(m => m.PmpModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'personas',
    loadChildren: () => import('./personas/personas.module')
      .then(m => m.PersonasModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'mapping',
    loadChildren: () => import('./mapa-curricular/mapa-curricular.module')
      .then(m => m.MapaCurricularModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'nivelaciones',
    loadChildren: () => import('./_modules/nivelaciones/nivelaciones.module')
      .then(m => m.NivelacionesModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'v22/unidad',
    loadChildren: () => import('./unidad/unidad.module')
      .then(m => m.UnidadModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'estudio',
    loadChildren: () => import('./_modules/estudio/estudio.module')
      .then(m => m.EstudioModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'unidades-buscar',
    loadChildren: () => import('./unidad-buscar/unidad-buscar.module')
      .then(m => m.UnidadesBuscarModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'clase-perdida-report',
    loadChildren: () => import('./clase-perdida-report/clase-perdida-report.module')
      .then(m => m.ClasePerdidaReportModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'requisiciones',
    loadChildren: () => import('./requisiciones/requisiciones.module')
      .then(m => m.RequisicionesModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'recuperaciones',
    loadChildren: () => import('./recuperaciones/recuperaciones.module')
      .then(m => m.RecuperacionesModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'home-beta',
    loadChildren: () => import('./home-beta/new-home.module')
      .then(m => m.NewHomeModule),
    canActivate: [AuthGuard]
  },
   {
    path: 'historico-data',
    loadChildren: () => import('./historico-record/historico-record.module')
      .then(m => m.HistoricoRecordModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'historico-record',
    component: HistoricoRecordComponent,
  },
  {
    path: 'photo-book',
    component: PhotoBookComponent,
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: '**',
    component: NotfoundComponent
  }
]; // TODO: definir estrategia de load para lazy loading.

/**
 * Configuration options for the app routing module.
 *
 * @property {boolean} enableTracing - Specifies whether to enable route tracing.
 * @property {string} relativeLinkResolution - Specifies the relative link resolution strategy.
 */
const config: any = { enableTracing: false };

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, config)],
  exports: [RouterModule],
  declarations: [],
  providers: [AuthGuard]
})
export class AppRoutingModule {
}
